import { Navigate } from 'react-router-dom'

/**
 * 由于项目菜单是后台生成，所以登录后需要动态寻址，默认重定向至菜单第一项
 *
 * @param menus 菜单列表
 * @returns Navigate 重定向到菜单第一项
 */
export default function ({ store, menus }) {
  const key = R.call(
    R.compose(
      R.defaultTo('/login'),
      R.prop('key'),
      R.head,
      R.ifElse(
          R.propIs(Array, 'children')
        , R.prop('children')
        , R.of
      ),
      R.defaultTo({}),
      R.head,
      R.defaultTo([]),
    ),
    menus,
  )

  const menu = R.flatten([ menus, menus.map(R.prop('children')) ]).filter(R.identity).find(data => {
    if (data.key == key) {
      return true
    }

    else {
      return false
    }
  })

  React.useEffect(() => {
    if (menu) {
      store.history.dispatch([
        {
            url: key
          , title: menu.label
        }
      ])
    }
  }, [])

  if (store.identity.isLogined() == false) {
    return <Navigate replace to='/login' />
  }

  else if (R.isNil(menus) || R.isEmpty(menus)) {
    return <Navigate replace to='/403' />
  }

  else {
    return <Navigate replace to={key} />
  }
}
